export class ProjectSearch {
  q: string = null;
  sale_status: string = null;
  sublocality: string = null;
}



// WEBPACK FOOTER //
// ./src/app/common-theme/models/project-search.model.ts